import EditContactName from './EditContactName';

export default EditContactName;
